// extracted by mini-css-extract-plugin
export default {"sqbb_title":"SqbbTitle_sqbb_title__s0qlg","sqbb_title_h":"SqbbTitle_sqbb_title_h__7LHPo","sqbb_title_underline":"SqbbTitle_sqbb_title_underline__GbmCE"};